/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<path pid="0" d="M7.633 1.184H5.537V.79C5.537.355 5.199 0 4.785 0h-1.56c-.414 0-.753.355-.753.79v.394H.376A.387.387 0 0 0 0 1.58c0 .217.17.395.376.395h.536l.376 5.654C1.344 8.398 1.955 9 2.698 9h2.604c.733 0 1.354-.602 1.41-1.372l.376-5.654h.536A.387.387 0 0 0 8 1.579c0-.217-.16-.395-.367-.395zm-4.39.79h1.514l-.15 6.237H3.383l-.14-6.237zM3.224.789h1.561v.395h-1.56V.79zM2.04 7.57l-.376-5.595h.827l.15 6.237c-.319-.03-.573-.306-.601-.642zm3.93 0a.682.682 0 0 1-.602.642l.15-6.237h.827L5.97 7.569z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
